// extracted by mini-css-extract-plugin
export var hits = "Hits-module--hits--FnkyX";
export var no_results = "Hits-module--no_results--sV3AM";